export const step = {
  PERSONAL_DATA: 'PERSONAL_DATA',
  MOBILE_CODE: 'MOBILE_CODE',
  PIN_CODE: 'PIN_CODE',
  VERYFY_IDENTITY: 'VERYFY_IDENTITY',
  FINAL_STAGE: 'FINAL_STAGE',
  CHECK_DATA: 'CHECK_DATA',
  REDIRECTION: 'REDIRECTION',
  CHECK_MAIL: 'CHECK_MAIL',
  PIN_CODE_LOGIN: 'PIN_CODE_LOGIN',
  INFO: 'INFO',
  VERDIDAS: 'VERDIDAS',
  CHECK_PHONE: 'CHECK_PHONE',
  CHECK_PASSWORD: 'CHECK_PASSWORD',
  FINAL_STAGE_NEW: 'FINAL_STAGE_NEW',
  HOW_MEET: 'HOW_MEET'
};

export const simpleRegisterStep = [
  { step: 'PERSONAL_DATA', name: 'Nombre y apellidos' },
  { step: 'CHECK_MAIL', name: 'Email' },
  { step: 'CHECK_PHONE', name: 'Teléfono' },
  { step: 'CHECK_PASSWORD', name: 'Contraseña' },
  { step: 'FINAL_STAGE', name: '¡Hecho!' }
];

export const showDataBeneficiary = {
  fav: '',
  name: 'Nombre',
  phone: 'Teléfono',
  email: 'Correo electrónico',
  country: 'País',
  city: 'Ciudad',
  codepostal: 'Código Postal',
  province: 'Provincia',
  borrar: 'Eliminar'
};

export const profileStep = {
  HOME: 'home',
  TRANSACTION: 'transaction',
  BENEFIT: 'beneficiary',
  INCIDENTS: 'incident',
  PROFILE: 'profile'
};

export const showDataAllTransactions = [
  'Destinatario',
  'Servicio',
  'Pais u Operador',
  'Fecha',
  'Estado',
  'Importe pagado'
];

export const showDataShipmentTransactions = [
  'Destinatario',
  'País',
  'Fecha',
  'Tiempo estimado de entrega',
  'Estado',
  'importe pagado'
];

export const showDataPhoneTransactions = [
  'ID',
  'Teléfono',
  'Operador',
  'Descripción',
  'Fecha',
  'Estado',
  'Importe pagado'
];

export const showDataTransactionsInSmallWindows = [
  'name',
  'createdAt',
  'paymentStatus',
  'cost',
  'eliminar'
];

export const showDataBeneficiaryInSmallWindows = ['name', 'phone', 'country', 'ciudad'];

export const headerTableShipmentBeneficiary = [
  '',
  'Nombre',
  'Teléfono',
  'Email',
  'Dirección',
  'Ciudad/Pais',
  'Eliminar'
];
export const headerTableTopUpBeneficiary = ['', 'Nombre', 'Teléfono', 'Operador', 'Eliminar'];

export const showDataIncidents = {
  incidentdescription: 'Descripción',
  close: 'Cerrada'
};

export const months = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre'
];

export const mobile = [
  { step: 'PERSONAL_DATA', name: 'Teléfono al que recargar' },
  { step: 'CHECK_MAIL', name: 'Seleccionar un paquete' },
  { step: 'CHECK_TARIFF', name: 'Revisa tu envío' },
  { step: 'FINAL_STAGE', name: '¡Hecho!' }
];
export const regExpPassword = new RegExp(
  '(?=(?:.*\\d){1,})(?=.*[A-Z])(?=.*[a-z])(?!.{0,n}(.)(?:.*\\1){3})\\S{8}'
);

export const headerTableMealPackBeneficiary = ['', 'Nombre', 'Teléfono', 'Email', 'Eliminar'];

export const revolupayRegisterStep = [
  'Datos personales',
  'Introduce tu dirección',
  'Valida tu identidad',
  '¡Hecho!'
];
export const selectOrderPackMeal = [
  { value: 'value order 1', label: 'label order 1' },
  { value: 'value order 2', label: 'label order 2' }
];

export const selectStorePackMeal = [
  { value: 'value store 1', label: 'label store 1' },
  { value: 'value store 2', label: 'label store 2' }
];
export const mealPacksSteps = [
  { step: 'SELECT_SHOP', name: 'Selecciona un supermercado' },
  { step: 'SELECT_PACK', name: 'Seleccionar una tarjeta' },
  { step: 'PUT_DATA', name: 'Introduce los datos' },
  { step: 'MAKE_PAYMENT', name: 'Realiza el pago' }
];
export const revolupaySteps = [
  { step: 'DESTINATION', name: 'Destino' },
  { step: 'DELIVERY', name: 'Entrega' },
  { step: 'BENEFICIARY', name: 'Beneficiario' },
  { step: 'PAYMENT_METHOD', name: 'Método de pago' },
  { step: 'CONFIRM_PAYMENT', name: 'Confirmar pago' },
  { step: 'FINAL_STAGE_REV', name: '¡Hecho!' }
];

// Options selects revolupay
export const estimatedDeliveryCubHabana = {
  es: '2-4 días hábiles (La Habana)',
  en: '2-4 business days (La Habana)'
};
export const estimatedDeliveryCubProvinces = {
  es: '4-6 días hábiles (Provincias)',
  en: '4-6 business days (Provinces)'
};

export const namesBeneficiaries = {
  firstName: 'name',
  lastName: 'surname',
  city: 'city',
  address: 'address',
  idCardNumber: 'documentNumber'
};

// module.exports = {
//   step,
//   profileStep,
//   showDataShipmentTransactions,
//   showDataPhoneTransactions,
//   showDataIncidents,
//   months,
//   mobile,
//   showDataTransactionsInSmallWindows,
//   showDataBeneficiaryInSmallWindows,
//   showDataAllTransactions,
//   simpleRegisterStep,
//   regExpPassword,
//   headerTableShipmentBeneficiary,
//   headerTableTopUpBeneficiary,
//   showDataBeneficiary
// };
